import React from 'react'

const TermsAndConditions = () => {
    return (
        <div>
            <h1>Terms and Conditions:</h1>
            <p>Pls no violate.</p>
        </div>
    )
}

export default TermsAndConditions